export function isFreePlan(pricing_plan_id: number){
    return pricing_plan_id === 27;
}

export function isHobbyPlan(pricing_plan_id: number){
    return pricing_plan_id === 32;
}